import React from 'react';
import { useSelector } from 'react-redux';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  return <>{children}</>;
};

export default PublicRoute;